import moment from 'moment-timezone';

function isFullscreen() {
    return !!document.fullscreenElement;
}

function openFullscreen(elem) {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
    }
}

function exitFullscreen() {
    if (!isFullscreen()) return;

    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
    }
}

function clone(obj) {
    return obj ? JSON.parse(JSON.stringify(obj)) : null;
}

function utcOffset() {
    var m = new Date().getTimezoneOffset();
    var sign = m < 0 ? '+' : '-';
    m = Math.abs(m / 60) + '';
    if (m.length === 1) m = '0' + m;
    return `${sign}${m}:00`;
}

function formatDateTime(dateTime, dateFormat, timezone) {
    var mdate = timezone && timezone.id ? moment.tz(dateTime, timezone.id) : moment(dateTime);
    return mdate.format(dateFormat);
}

export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function getCulture() {
    return window.navigator.languages ? window.navigator.languages[0] : window.navigator.userLanguage || window.navigator.language;
}

function browserLanguage() {
    return /^(\w{2})/i.exec(getCulture())[1].toLowerCase();
}

export function registerServiceWorker(serviceWorkerPath) {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register(serviceWorkerPath || '/sw.js')
                .then(registration => {
                    console.log('SW registered: ', registration);
                })
                .catch(registrationError => {
                    console.log('SW registration failed: ', registrationError);
                });
        });
    }
}

var getQueryStringParameter = function(field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? decodeURIComponent(string[1]) : null;
};

export function focusAndOpenKeyboard(id) {
    const fakeInput = document.createElement('input');
    fakeInput.setAttribute('type', 'text');
    fakeInput.style.position = 'absolute';
    fakeInput.style.opacity = 0;
    fakeInput.style.height = 0;
    fakeInput.style.fontSize = '16px'; // disable auto zoom

    // you may need to append to another element depending on the browser's auto
    // zoom/scroll behavior
    document.body.prepend(fakeInput);

    // focus so that subsequent async focus will work
    fakeInput.focus();

    setTimeout(() => {
        // now we can focus on the target input
        document.getElementById(id).focus();

        // cleanup
        fakeInput.remove();
    }, 1500);
}

// debounce from 
export function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export default {
    isFullscreen,
    openFullscreen,
    exitFullscreen,
    registerServiceWorker,
    clone,
    utcOffset,
    formatDateTime,
    uuid,
    browserLanguage,
    getQueryStringParameter,
    focusAndOpenKeyboard,
    debounce
};



// WEBPACK FOOTER //
// ./_common/utils.js